import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { cn } from "styles/utils"

const Badge = ({ className, label, variant }) => {
  const holdbackExp = useSelector(
    (state) => state.experiment.holdback.variant_id
  )

  return (
    <span
      className={cn(
        "z-1 bg-polar text-12 leading-14 absolute inline-flex items-center justify-center rounded-lg px-8 py-2 text-black",
        holdbackExp === 1
          ? "left-20 top-5"
          : "desktop:left-20 desktop:top-20 left-8 top-8",
        variant === "sale" && "bg-sale text-white",
        variant === "christmas" && "bg-emerald text-white",
        variant === "sky" && "bg-sky text-white",
        variant === "deal" && "bg-[#FBE3E3]",
        variant === "kid" && "bg-[#DCD2E7]",
        variant === "vday" && "bg-[#FCF2F2]",
        variant === "xmas_delivery" && "bg-[#E4F2E0]",
        variant === "lee_fiori" && "bg-[#EEEDE6]",
        className
      )}
    >
      {label}
    </span>
  )
}

Badge.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.string,
}

export default Badge
